var _circle, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    id: "tick",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 21.5,
    fill: "#E1F5FE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0277BD",
    d: "M24 46C11.869 46 2 36.131 2 24S11.869 2 24 2a22.04 22.04 0 0 1 16.342 7.271.499.499 0 1 1-.742.67A21.04 21.04 0 0 0 24 3C12.421 3 3 12.42 3 24s9.421 21 21 21 21-9.42 21-21c0-2.299-.369-4.56-1.098-6.72a.499.499 0 1 1 .947-.319A21.96 21.96 0 0 1 46 24c0 12.131-9.869 22-22 22z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M24 45C12.421 45 3 35.58 3 24S12.421 3 24 3a21.07 21.07 0 0 1 15.419 6.743.5.5 0 0 1-.734.679A20.066 20.066 0 0 0 24 4C12.972 4 4 12.972 4 24s8.972 20 20 20 20-8.972 20-20c0-2.03-.303-4.031-.899-5.948a.5.5 0 1 1 .955-.297C44.683 19.768 45 21.869 45 24c0 11.58-9.421 21-21 21z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#64FFDA",
    d: "M21.584 33.834c.892.888 2.438.888 3.331 0l19.387-19.309a2.369 2.369 0 0 0 0-3.359c-.892-.888-2.438-.888-3.33 0L24.007 28.061c-.399.398-1.116.398-1.516 0l-6.463-6.436c-.446-.444-1.037-.688-1.665-.688s-1.22.244-1.665.688a2.369 2.369 0 0 0 0 3.359l8.886 8.85z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#0277BD",
    d: "M23.249 35.005a2.852 2.852 0 0 1-2.018-.817l-8.886-8.85a2.851 2.851 0 0 1-.846-2.035c0-.769.301-1.491.846-2.033 1.077-1.074 2.954-1.076 4.035 0l6.463 6.436c.205.204.606.205.81 0L40.619 10.81c1.094-1.089 2.941-1.089 4.035 0a2.85 2.85 0 0 1 .846 2.034c0 .769-.301 1.491-.846 2.033L25.268 34.188a2.854 2.854 0 0 1-2.019.817zm-8.886-13.568a1.85 1.85 0 0 0-1.312.542c-.355.354-.552.824-.552 1.325s.195.972.551 1.325l8.886 8.851c.699.695 1.927.696 2.626 0l19.387-19.31c.354-.353.551-.824.551-1.325s-.195-.972-.551-1.325c-.699-.696-1.926-.697-2.625 0L24.359 28.416c-.59.59-1.63.59-2.222 0l-6.462-6.436a1.843 1.843 0 0 0-1.312-.543z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M13 23.804a.5.5 0 0 1-.5-.5c0-.5.196-.971.552-1.325.351-.35.816-.542 1.312-.542a.5.5 0 0 1 0 1 .856.856 0 0 0-.606.25.871.871 0 0 0-.257.617.501.501 0 0 1-.501.5zm13.161 4.024a.502.502 0 0 1-.352-.855l14.07-14.013a.5.5 0 1 1 .705.709l-14.07 14.013a.5.5 0 0 1-.353.146z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTick);
export default __webpack_public_path__ + "static/media/tick.7c8da86c3d36add884a7447ceafd7d67.svg";
export { ForwardRef as ReactComponent };